import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/views/Dashboard'
import Signup from '@/views/onBoarding/Signup'
import Login from '@/views/onBoarding/Login'
import ForgotPassword from '@/views/onBoarding/ForgotPassword'
import ResetPassword from '@/views/onBoarding/ResetPassword'
import AccountDetails from '@/views/onBoarding/AccountDetails'
import AccountDetailsOwner from '@/views/onBoarding/AccountDetailsOwner'
import TermsAndConditions from '@/views/onBoarding/TermsAndConditions'
import Orders from '@/views/orders/Orders'
import OrderDetails from '@/views/orders/OrderDetails'
import Products from '@/views/products/Products'
import AddProduct from '@/views/products/AddProduct'
import ShippingMethods from '@/views/shipping/ShippingMethods'
import Payments from '@/views/Payments'
import Settings from '@/views/Settings'

import { authGuard } from '../auth/authGuard'
import { loginGuard } from '../auth/loginGuard'

Vue.use(Router)

export default new Router({
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: authGuard
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      beforeEnter: loginGuard
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: loginGuard
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      beforeEnter: loginGuard
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/account-details',
      name: 'AccountDetails',
      component: AccountDetails,
      beforeEnter: authGuard
    },
    {
      path: '/account-details-owner',
      name: 'AccountDetailsOwner',
      component: AccountDetailsOwner,
      beforeEnter: authGuard
    },
    {
      path: '/terms-and-conditions',
      name: 'TermsAndConditions',
      component: TermsAndConditions,
      beforeEnter: authGuard
    },
    {
      path: '/orders',
      name: 'Orders',
      component: Orders,
      beforeEnter: authGuard
    },
    {
      path: '/order-details/:id',
      name: 'OrderDetails',
      component: OrderDetails,
      beforeEnter: authGuard
    },
    {
      path: '/products',
      name: 'Products',
      component: Products,
      beforeEnter: authGuard
    },
    {
      path: '/product-details/:id',
      name: 'EditProduct',
      component: AddProduct,
      beforeEnter: authGuard
    },
    {
      path: '/add-product',
      name: 'AddProduct',
      component: AddProduct,
      beforeEnter: authGuard
    },
    {
      path: '/shipping-methods',
      name: 'ShippingMethods',
      component: ShippingMethods,
      beforeEnter: authGuard
    },
    {
      path: '/payments',
      name: 'Payments',
      component: Payments,
      beforeEnter: authGuard
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      beforeEnter: authGuard
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js